import { render, staticRenderFns } from "./RoleItem.vue?vue&type=template&id=b724f088&scoped=true&"
import script from "./RoleItem.vue?vue&type=script&lang=js&"
export * from "./RoleItem.vue?vue&type=script&lang=js&"
import style0 from "./RoleItem.vue?vue&type=style&index=0&id=b724f088&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b724f088",
  null
  
)

export default component.exports